import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoTomorrowland = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.96 5.74a8.66 8.66 0 0 1 11.33 0c.2-.184.387-.381.56-.59a3.34 3.34 0 0 1-.75-1.92 2.65 2.65 0 0 1-2.3.11l-.28-.09A6.14 6.14 0 0 1 11.63 1a6 6 0 0 1-2.95 2.26l-.15.05a2.72 2.72 0 0 1-2.39-.08 3.29 3.29 0 0 1-.74 1.91c.17.215.358.415.56.6Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.891 5.145a1.34 1.34 0 1 1 1.518 2.209 1.34 1.34 0 0 1-1.518-2.209Zm.12 1.165a.48.48 0 0 0 .319.13l-.01.05a.47.47 0 0 0 .46-.49.46.46 0 0 0-.46-.48.47.47 0 0 0-.46.48.48.48 0 0 0 .15.31Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.464 4.655a4.08 4.08 0 0 1 2.166-.515 4.08 4.08 0 0 1 3.74 2.09s-.21.7-1.74 1.7a4.14 4.14 0 0 0-2 2.43 4.09 4.09 0 0 0-2-2.43c-1.53-1.01-1.74-1.7-1.74-1.7a4.08 4.08 0 0 1 1.574-1.575ZM8.63 6.23a4.66 4.66 0 0 0 3 1.56 4.7 4.7 0 0 0 3-1.56 3.67 3.67 0 0 0-3-1.55 3.65 3.65 0 0 0-3 1.55Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M20.29 12.3v-.13h.01c.27-.271.511-.57.72-.89.064.484.097.972.1 1.46 0 7.33-9.49 10.26-9.49 10.26s-9.49-2.72-9.49-10.26c.003-.492.036-.983.1-1.47.209.32.45.619.72.89v.14a8.67 8.67 0 0 0 17.33 0Z"
    />
    <path
      fill="currentColor"
      d="M8.708 8.274C6.975 7.192 4.534 5.667 4.43 4.18c-6.94 7.22 3.1 10 3.1 10s-2.21.47-2.21 2C5.33 18.86 9.15 20 9.15 20s2.22-.72 2.22-6.41c0-2.5-.39-3.87-1.94-4.86-.218-.14-.462-.293-.722-.456ZM14.512 8.295c-.248.154-.482.3-.692.435l.01-.04c-1.54.99-1.94 2.36-1.94 4.86 0 5.69 2.22 6.41 2.22 6.41s3.83-1.14 3.83-3.78c0-1.53-2.21-2-2.21-2s10.03-2.78 3.09-10c-.105 1.496-2.568 3.03-4.308 4.115Z"
    />
  </svg>
);
export default SvgLogoTomorrowland;
